import { useState } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts, categories } from '../data/blogPosts';

export default function BlogPage() {
  const [activeCat, setActiveCat] = useState('All');
  const filtered = activeCat === 'All' ? blogPosts : blogPosts.filter(p => p.category === activeCat);
  const featured = filtered.filter(p => p.featured);
  const rest = filtered.filter(p => !p.featured);

  return (
    <div className="fade-up" style={{ maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', padding: '40px 20px 20px' }}>
        <div style={{ display: 'inline-flex', background: '#FFF0EB', color: '#FF642D', fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 99, letterSpacing: '0.05em', marginBottom: 16 }}>SEO BLOG • AI SEARCH BLOG</div>
        <h1 style={{ fontSize: 42, fontWeight: 800, letterSpacing: '-0.03em', lineHeight: 1.1, marginBottom: 12 }}>SEO Blog &<br/>AI Search Blog</h1>
        <p style={{ fontSize: 16, color: '#6B7280', maxWidth: 600, margin: '0 auto 24px' }}>Learn SEO, keyword research, backlinks, technical SEO and AI Search Optimization. Real guides to rank on Google AND ChatGPT/Perplexity.</p>
        
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          {categories.map(cat => (
            <button key={cat} onClick={() => setActiveCat(cat)} className={`btn btn-sm ${activeCat === cat ? 'btn-black' : 'btn-white'}`}>{cat}</button>
          ))}
        </div>
      </div>

      {featured.length > 0 && (
        <div style={{ padding: '20px' }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#6B7280', marginBottom: 12 }}>Featured • SEO + AI Search</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16 }}>
            {featured.map(post => (
              <Link key={post.slug} to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                <div className="card" style={{ margin: 0, height: '100%', borderColor: '#111', borderWidth: 2 }}>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                    <span className="badge badge-orange">{post.category}</span>
                    <span className="badge badge-gray">{post.readTime}</span>
                    <span style={{ fontSize: 11, color: '#6B7280', marginLeft: 'auto' }}>{post.date}</span>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 18, lineHeight: 1.3, marginBottom: 8 }}>{post.title}</div>
                  <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 1.5, marginBottom: 12 }}>{post.metaDescription.slice(0, 120)}...</div>
                  <div style={{ fontSize: 11, color: '#FF642D', fontWeight: 700 }}>Read →</div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}

      <div style={{ padding: '20px' }}>
        <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#6B7280', marginBottom: 12 }}>All Articles ({filtered.length})</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 12 }}>
          {filtered.map(post => (
            <Link key={post.slug} to={`/blog/${post.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card" style={{ margin: 0, height: '100%' }}>
                <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                  <span className="badge badge-gray" style={{ fontSize: 10 }}>{post.category}</span>
                  <span style={{ fontSize: 11, color: '#6B7280' }}>{post.readTime} • {post.date}</span>
                </div>
                <div style={{ fontWeight: 700, fontSize: 14, lineHeight: 1.3, marginBottom: 6 }}>{post.title}</div>
                <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.4 }}>{post.metaDescription.slice(0, 100)}...</div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div style={{ margin: 20, background: '#111', color: 'white', borderRadius: 12, padding: 24, textAlign: 'center' }}>
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 8 }}>Want to rank on Google + ChatGPT?</div>
        <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 16 }}>Use Sungresh to find SEO keywords AND AI search keywords</div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
          <Link to="/keywords/magic" className="btn" style={{ background: '#FF642D', color: 'white' }}>Find Keywords Free</Link>
          <Link to="/domain/overview" className="btn btn-white">Analyze Domain</Link>
        </div>
      </div>
    </div>
  );
}
